import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

import { Dropdown, Btn } from "uiv";
import { computed, ref } from "vue";
import UserAvatar from "../reusables/user-avatar.vue";
import { UserProfileApiModel } from "../../api-models";
import useWindowWidth from "../../composables/useWindowWidth";


export default /*#__PURE__*/_defineComponent({
  __name: 'avatar-dropdown',
  props: {
    users: {},
    usersWhoHaveCompleted: {},
    triggerText: {},
    actionType: {}
  },
  setup(__props: any) {

const props = __props;

const show = ref(false);

const { width } = useWindowWidth();

const displayMenuLeft = computed(() => {
  return width.value < 552;
});

function avatarVariant(user: UserProfileApiModel) {
  if (props.actionType === "Invite") return "default";
  return props.usersWhoHaveCompleted.includes(user) ? "default" : "faded";
}

function getTooltipText(user: UserProfileApiModel) {
  if (props.actionType === "Invite") return `${user.firstName} ${user.lastName}`;
  return props.usersWhoHaveCompleted.includes(user)
    ? `${user.firstName} ${user.lastName} (completed)`
    : `${user.firstName} ${user.lastName} (incomplete)`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "avatar-menu",
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_unref(Dropdown), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      class: "edit-dropdown",
      "menu-right": !displayMenuLeft.value,
      "menu-left": displayMenuLeft.value,
      "data-test": "avatars-dropdown"
    }, {
      dropdown: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
          return (_openBlock(), _createElementBlock("li", {
            key: user.id,
            class: "avatar-dropdown-item",
            "data-test": "avatars-dropdown-list-item"
          }, [
            _createVNode(UserAvatar, {
              user: user,
              size: "30px",
              variant: avatarVariant(user),
              "tooltip-text": getTooltipText(user)
            }, null, 8, ["user", "variant", "tooltip-text"]),
            _createElementVNode("span", {
              style: _normalizeStyle({ opacity: avatarVariant(user) === 'faded' ? 0.5 : 1 })
            }, _toDisplayString(getTooltipText(user)), 5)
          ]))
        }), 128))
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Btn), {
          type: "button",
          class: _normalizeClass(["btn btn-trigger dropdown-toggle", { 'dropdown-selected': show.value }]),
          "data-test": "avatars-trigger-button"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.triggerText), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue", "menu-right", "menu-left"])
  ]))
}
}

})